import React from 'react';

import { McpIcon } from 'pages/Landings/components/Icons';
import Paragraph from 'pages/Landings/components/Paragraph';
import TopicContent from 'pages/Landings/components/TopicContent';
import TopicHeading from 'pages/Landings/components/TopicHeading';
import TopicTemplate from 'pages/Landings/components/TopicTemplate';

const Mcp: React.FC = () => {
    return (
        <TopicTemplate
            heading={
                <TopicHeading
                    title="MCP"
                    description="Use Vulners MCP to power your AI agents. Break through the LLM knowledge cut-off and use real-time vulnerability insight."
                    illustration={<McpIcon />}
                />
            }
            content={
                <TopicContent link="https://docs.vulners.com/docs/products/mcp/">
                    <Paragraph
                        primary="Ground Your Agents in Live Facts"
                        secondary="Ground your copilots in live facts. Instead of stuffing prompts with stale KBs, agents pass a CVE or product name and receive structured, current context on demand - affected versions, severity, exploits, and patches - reducing hallucinations while beating model knowledge cutoffs and trimming token bloat."
                    />
                    <Paragraph
                        primary="Drop-In Integration Where You Build"
                        secondary="Integration is straightforward. Vulners MCP works with modern frameworks (Model Context Protocol, CrewAI tools), so you can add trustworthy security answers to chatbots and assistants fast. Differentiate your product by showing today’s CVE with today’s facts, complete with links and remediation context that users can verify."
                    />
                    <Paragraph
                        primary="Fuel Ops and Triage"
                        secondary="Focus engineers on UX and agent behavior while Vulners supplies always-current vulnerability intelligence. The same capabilities accelerate internal ops too: impact checks, incident triage, and summaries that never say, “I don’t know that CVE.”"
                    />
                </TopicContent>
            }
        />
    );
};

export default Mcp;
